import { Flex, Hide } from '@chakra-ui/react';

import { Header } from '../../components';
import { useGetAllPlans } from '../../hooks';

import { PlansList } from './PlansList';
import { PlansListSkeleton } from './PlansList.Skeleton';
import { PlansMyProducts } from './PlansMyProducts';

const ROOT_ENTITY = 'checkout/plans';

export const Plans = () => {
  const { data, isFindingPlans } = useGetAllPlans();

  return (
    <Flex
      flexDir="column"
      w="full"
      p={{ base: 0, lg: 5 }}
      maxH="100dvh"
      h="100dvh"
    >
      <Header
        currentStep={1}
        rootEntity={ROOT_ENTITY}
        cart={<PlansMyProducts />}
      />

      <Flex
        gap={5}
        flexDir={{ base: 'column', lg: 'row' }}
        p={{ base: 4, lg: 0 }}
      >
        <Flex flexDir="column" gap={6} w="full">
          {isFindingPlans ? <PlansListSkeleton /> : <PlansList data={data} />}
        </Flex>

        <Hide below="lg">
          <PlansMyProducts />
        </Hide>
      </Flex>
    </Flex>
  );
};
